import React from "react"
import { FaRegQuestionCircle } from "react-icons/fa"

import FaqStyles from "./faq.module.scss"

const questions = [
  {
    q: "What if I want to only take appointments on certain days?",
    a:
      "If you notify us of the days you would like to make appointments we will ensure appointments can only be made on these days.",
  },
  {
    q: "Does the phone and text system come with the appointment system?",
    a:
      "No the phone and text system is on a pay as you go method. The systems cost $2 a day to use.",
  },
  {
    q: "Will I be able to sell products?",
    a: "Yes, as long as you purchase a premium or better package.",
  },
  {
    q: "Will the mobile app be available for download in app stores?",
    a:
      "We can upload the app to the app store for a $200 fee + the app store fees.",
  },
]

const FAQ = () => (
  <section className={FaqStyles.faqSection}>
    <h3 className="section-subheading">Want to know more?</h3>
    <h2 className="section-heading">Frequently Asked Questions</h2>

    <div className={FaqStyles.grid}>
      {questions.map((question, i) => (
        <div key={i} className={FaqStyles.faqBox}>
          <FaRegQuestionCircle className={FaqStyles.icon} />
          <div className={FaqStyles.faqBoxText}>
            <h4>{question.q}</h4>
            <p>{question.a} </p>
          </div>
        </div>
      ))}
    </div>
    {/* 
    <button>View more questions</button> */}
  </section>
)

export default FAQ
